"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_DISABLE_MATOMO_TRACKING = exports.DATA_SOLR_SUGGESTION_CONTAINER = exports.DATA_SOLR_SEARCH_HEADLINE = exports.DATA_SOLR_INPUT_SUGGEST = exports.DATA_SOLR_FORM = exports.NAME_SOLR_SUGGEST_FORM_AJAX_PARAMETER = exports.DATA_FILTER_PRODUCTS_SUBMIT_BUTTON = exports.DATA_FILTER_PRODUCTS_OPTIONS_MATERIALS = exports.DATA_FILTER_PRODUCTS_OPTIONS_BRANCHES = exports.DATA_FILTER_PRODUCTS_SELECT_MATERIALS = exports.DATA_FILTER_PRODUCTS_SELECT_BRANCHES = exports.DATA_FILTER_OBJECT = exports.DATA_FILTER_PRODUCTS = exports.DATA_QUOTES_SLIDER = exports.DATA_QUOTES = exports.DATA_FORM_FIELD_ERROR_TEXT = exports.DATA_FORM_FIELD_ERROR = exports.DATA_FORM_FIELD = exports.DATA_FORM_FIELD_WRAP = exports.DATA_FORM_SUBMIT_ICON = exports.DATA_FORM_SUBMIT_TEXT = exports.DATA_FORM_SUBMIT = exports.DATA_FORM = exports.DATA_FLOATING_LINK = exports.DATA_FLOATING_CTA = exports.DATA_KEYFIGURES_END = exports.DATA_KEYFIGURES_START = exports.DATA_KEYFIGURES_NUMBER = exports.DATA_KEYFIGURES = exports.DATA_SUBMENU_LV3_CLOSE = exports.DATA_SUBMENU_CLOSE = exports.DATA_SUBMENU_LV3_PLACEHOLDER = exports.DATA_SUBMENU_LV3 = exports.DATA_SUBMENU_LINK = exports.DATA_SUBMENU = exports.DATA_TOGGLE_SUBMENU_LV3 = exports.DATA_TOGGLE_SUBMENU = exports.DATA_NAV_LINK = exports.DATA_NAVBAR_COLLAPSE = exports.DATA_NAVBAR_TOGGLE = exports.DATA_NAVBAR_NAV = exports.DATA_NAVBAR = exports.DATA_STICKY_HEADER = exports.DATA_ACCORDION = exports.DATA_SLIDER = void 0;
// Splide SLider
exports.DATA_SLIDER = 'data-slider';
// Accordion
exports.DATA_ACCORDION = 'data-accordion';
// Sticky Header
exports.DATA_STICKY_HEADER = 'data-sticky-header';
// Menu Navigation
exports.DATA_NAVBAR = 'data-navbar';
exports.DATA_NAVBAR_NAV = 'data-navbar-nav';
exports.DATA_NAVBAR_TOGGLE = 'data-navbar-toggle';
exports.DATA_NAVBAR_COLLAPSE = 'data-navbar-collapse';
exports.DATA_NAV_LINK = 'data-nav-link';
exports.DATA_TOGGLE_SUBMENU = 'data-toggle-submenu';
exports.DATA_TOGGLE_SUBMENU_LV3 = 'data-toggle-submenu-lv3';
exports.DATA_SUBMENU = 'data-submenu';
exports.DATA_SUBMENU_LINK = 'data-submenu-link';
exports.DATA_SUBMENU_LV3 = 'data-submenu-lv3';
exports.DATA_SUBMENU_LV3_PLACEHOLDER = 'data-submenu-lv3-placeholder';
exports.DATA_SUBMENU_CLOSE = 'data-submenu-close';
exports.DATA_SUBMENU_LV3_CLOSE = 'data-submenu-lv3-close';
// Keyfigures
exports.DATA_KEYFIGURES = 'data-keyfigures';
exports.DATA_KEYFIGURES_NUMBER = 'data-keyfigures-number';
exports.DATA_KEYFIGURES_START = 'data-keyfigures-start';
exports.DATA_KEYFIGURES_END = 'data-keyfigures-end';
// Floating CTA
exports.DATA_FLOATING_CTA = 'data-floating-cta';
exports.DATA_FLOATING_LINK = 'data-floating-link';
// Forms
exports.DATA_FORM = 'data-form';
exports.DATA_FORM_SUBMIT = 'data-form-submit';
exports.DATA_FORM_SUBMIT_TEXT = 'data-form-submit-text';
exports.DATA_FORM_SUBMIT_ICON = 'data-form-submit-icon';
exports.DATA_FORM_FIELD_WRAP = 'data-form-field-wrap';
exports.DATA_FORM_FIELD = 'data-form-field';
exports.DATA_FORM_FIELD_ERROR = 'data-form-field-error';
exports.DATA_FORM_FIELD_ERROR_TEXT = 'data-form-field-error-text';
// Quotes
exports.DATA_QUOTES = 'data-quotes';
exports.DATA_QUOTES_SLIDER = 'data-quotes-slider';
// Product Filter
exports.DATA_FILTER_PRODUCTS = 'data-filter-products';
exports.DATA_FILTER_OBJECT = 'data-filter-object';
exports.DATA_FILTER_PRODUCTS_SELECT_BRANCHES = 'data-filter-products-select-branches';
exports.DATA_FILTER_PRODUCTS_SELECT_MATERIALS = 'data-filter-products-select-materials';
exports.DATA_FILTER_PRODUCTS_OPTIONS_BRANCHES = 'data-filter-products-options-branches';
exports.DATA_FILTER_PRODUCTS_OPTIONS_MATERIALS = 'data-filter-products-options-materials';
exports.DATA_FILTER_PRODUCTS_SUBMIT_BUTTON = 'data-filter-products-submit-button';
// SOLR
exports.NAME_SOLR_SUGGEST_FORM_AJAX_PARAMETER = 'tx_solr[queryString]';
exports.DATA_SOLR_FORM = 'data-solr-form';
exports.DATA_SOLR_INPUT_SUGGEST = 'data-solr-input-suggest';
exports.DATA_SOLR_SEARCH_HEADLINE = 'data-solr-search-headline';
exports.DATA_SOLR_SUGGESTION_CONTAINER = 'data-solr-suggestion-container';
// Disable Tracking Links
exports.DATA_DISABLE_MATOMO_TRACKING = 'data-disable-matomo-tracking';
